import React, {useEffect} from "react";
import {useHistory} from "react-router-dom";

import './style.less'
import HorizontalNavBar from "../../components/HorizontalNavBar";
import LoginContainer from "./containers/LoginContainer";
import RecoverContainer from "./containers/RecoverContainer";
import VerificationContainer from "./containers/VerificationContainer";
import {useAuth} from "../../services/authServices";
import accountNeedsConfiguration from "../../utils/accountConfiguration";

const pages = [
    {
        label: "start.login.nav",
        path: "login",
        component: LoginContainer,
    },
    {
        path: "recover",
        component: RecoverContainer,
    },
    {
        path: "verification",
        component: VerificationContainer,
    }
];

const Start = () => {

    const {user, onLoaded} = useAuth();
    const history = useHistory();

    useEffect(() => {
        (async () => {
            let user = await onLoaded();
            if (user) {
                if (accountNeedsConfiguration(user)) {
                    console.log("account needs configuration");
                    !window.location.href.includes("/start/verification") && history.push('/start/verification');
                } else {
                    console.log("account is configured");
                    history.push('/dashboard');
                }
            }
        })();
    }, [user])

    let pathSplit = location.pathname?.split("/");
    let currentPath = pathSplit[pathSplit?.length - 1];

    return (
        <>
            <div className="Start">
                <div className="auth-container">
                    <HorizontalNavBar path={"/start"} pages={pages} basicContainer={true} type={'start_page'} />
                </div>
            </div>
        </>
    );
};


export default Start;
